import { render, staticRenderFns } from "./Wp_pdd_my_child_member.vue?vue&type=template&id=2594bf06&"
import script from "./Wp_pdd_my_child_member.vue?vue&type=script&lang=js&"
export * from "./Wp_pdd_my_child_member.vue?vue&type=script&lang=js&"
import style0 from "./Wp_pdd_my_child_member.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports